import config from '../config/config'
import AuthenticationHelper from './AuthenticationHelper'
import GeneralHelper from './GeneralHelper'

class AuthRequest{

    //make a request using the stored token
    request(mode,location,params){
        //cases when mode requires body
        let requestOptions = {
            method: mode.toUpperCase(),
            mode: "cors",
            cache: "no-cache",
            headers: {
                "Authorization": "Bearer "+AuthenticationHelper.token
            }
        }
        let url=config.localAuth.apiServiceUrl+location;
        if(mode.toLowerCase()==="get")
        {
            let getQueryString= GeneralHelper.serializeGetUrl(params)
            url=url+"?"+getQueryString
        }

        //console.log(mode.toLowerCase())
        if(mode.toLowerCase()==="post" || mode.toLowerCase()==="put" || mode.toLowerCase()==="patch" || mode.toLowerCase()==="delete"  ) {
            requestOptions.body= JSON.stringify(params)
            requestOptions.headers["Content-Type"]="application/json";
        }
        let response_status=0
        return fetch(url,requestOptions)
        .then(r => {
            response_status = r.status
            // read as text first so we can safely handle non-JSON responses
            return r.text().then(text => {
                let parsed = null
                if (text && text.length) {
                    try {
                        parsed = JSON.parse(text)
                    } catch(e) {
                        // not JSON, keep raw text
                        parsed = text
                    }
                }
                return parsed
            })
        })
        .then(response => {
            if(response_status!==200)//error
            {
                if (response_status===401){
                    throw new Error ("Invalid Credentials")
                }
                else{
                    // include server-provided message when available
                    const serverMsg = (response && (response.message || response.error || response.code)) || 'no details'
                    throw new Error ("Unspecified server error for path=/"+location+' , status:'+ serverMsg);
                }
            }
            else
            {
                return response
            }
        })
        .catch(err => {
            // Normalize network/CORS/fetch errors with a clearer message
            throw new Error('Network error when attempting to fetch resource: ' + (err && err.message ? err.message : String(err)))
        })
    }

    /*Make a request not using the token*/
    requestNoToken(mode,location,params){
        //cases when mode requires body
        let requestOptions = {
            method: mode.toUpperCase(),
            mode: "cors",
            cache: "no-cache",
            headers: {}
        }
        let url=config.localAuth.apiServiceUrl+location;
        if(mode.toLowerCase()==="get")
        {
            let getQueryString= GeneralHelper.serializeGetUrl(params)
            url=url+"?"+getQueryString
        }

        if(mode.toLowerCase()==="post" || mode.toLowerCase()==="put" || mode.toLowerCase()==="patch" || mode.toLowerCase()==="delete"  ) {
            requestOptions.body= JSON.stringify(params)
            requestOptions.headers["Content-Type"]="application/json";
        }
        let response_status=0
        return fetch(url,requestOptions)
        .then(r => {
            response_status = r.status
            return r.text().then(text => {
                let parsed = null
                if (text && text.length) {
                    try { parsed = JSON.parse(text) } catch(e) { parsed = text }
                }
                return parsed
            })
        })
        .then(response => {
            if(response_status!==200)//error
            {
                const serverMsg = (response && (response.message || response.error || response.code)) || 'no details'
                throw new Error ("Unspecified server error for path=/"+location+' , status:'+ serverMsg);
            }
            else
            {
                return response
            }
        })
        .catch(err => {
            throw new Error('Network error when attempting to fetch resource: ' + (err && err.message ? err.message : String(err)))
        })
    }
}

export default new AuthRequest();